import React, { useEffect, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import cn from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import styles from './Nav.module.scss';
import Image from '../../Image';
import logo from '../../../assets/logo.jpg';
import cart from '../../../assets/nav/cart.png';
import menu from '../../../assets/nav/menu.png';
import { routes } from '../../../routes';
import useQueryString from '../../../hooks/use-query-string';
import useBreakpoints from '../../../hooks/use-breakpoints';
import MobileNav from './MobileNav';
import useNumCartItems from '../../../hooks/useNumCartItems';
import { useCustomer } from '../../../contexts/CustomerContext';

export default function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAP, setIsOpenAP] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const { pathname } = useLocation();
  const q = useQueryString();
  const breakpoint = useBreakpoints();
  const { customer } = useCustomer();

  const getCurrentDomain = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('shoob.cloud')) {
      return 'https://www.shoob.cloud';
    } else {
      return 'https://www.shoobphoto.com';
    }
  }

  const { data } = useNumCartItems({ id: customer?.cart?.id, email: customer?.cart?.email || customer?.email });

  useDeepCompareEffect(() => {
    setIsOpen(false);
    setIsLoginOpen(false);
  }, [pathname, q]);
  useEffect(() => {
    if (!isOpen) return;

    setIsLoginOpen(false);
  }, [isOpen]);

  useEffect(() => {
    if (!isLoginOpen) return;

    setIsOpen(false);
  }, [isLoginOpen]);

  const isSignedIn = document.querySelector('#current-user');

  if (['lg', 'md', 'sm'].includes(breakpoint)) return <MobileNav />;

  return (
    <nav
      className={cn({
        [styles.navContainer]: true,
        [styles.pb]: pathname !== '/',
      })}
    >
      <div className={cn(styles.cartLink, styles.dropdown)} style={{ marginLeft: '1em' }}>
        <button
          className={styles.button}
          style={{ padding: '.5em' }}
          onClick={() => setIsLoginOpen(!isLoginOpen)}
          type="button"
        >
          <Image alt="Menu" src={menu} />
        </button>
        <ul
          className={cn({
            [styles.dropdownMenu]: true,
            [styles.hidden]: !isLoginOpen,
          })}
        >
          <li>
            <a href={isSignedIn ? '/pages/home' : '/users/sign_in'}>
              {isSignedIn ? 'Home Page' : 'School Login'}
            </a>
          </li>
          {!isSignedIn && (
            <li>
              <a href="/users/sign_in">
                Shoob Employee Login
              </a>
            </li>
          )}
        </ul>
      </div>
      <Link to="/">
        <Image src={logo} classes={styles.logo} />
      </Link>
      <ul className={styles.nav}>
        <li className={styles.dropdown}>
          <button
            className={styles.button}
            onClick={() => setIsOpen(!isOpen)}
            type="button"
          >
            Order
          </button>
          <ul
            className={cn({
              [styles.dropdownMenu]: true,
              [styles.hidden]: !isOpen,
            })}
          >
            <li>
              <Link to={routes.studentIdEntry()}>
                School Pictures
              </Link>
            </li>
            <li>
              <Link to={routes.studentIdEntry({ order: 'senior' })}>
                Senior Portraits
              </Link>
            </li>
            <li>
              <Link to={routes.studentIdEntry({ order: 'yearbook_order' })}>
                Yearbooks
              </Link>
            </li>
            <li>
              <Link to={routes.studentIdEntry({ order: 'panorama' })}>
                Groups and Panorama
              </Link>
            </li>
          </ul>
        </li>

        <li>
          <a href="/seniors">
            Seniors
          </a>
        </li>

        <li className={styles.dropdown}>
          <button
            className={styles.button}
            onClick={() => setIsOpenAP(!isOpenAP)}
            type="button"
          >
            Book Appointment
          </button>
          <ul
            className={cn({
              [styles.dropdownMenu]: true,
              [styles.hidden]: !isOpenAP,
            })}
          >
            <li>
              {/* Pin the senior-sessions package id (601 — see
                  `seniors_controller.rb` SESSIONS_PACKAGE_ID) so the schedule-
                  appointment page doesn't fall back to the school's first
                  highSchoolSittings package (often the Retake package). */}
              <Link to={routes.scheduleAppointment({ senior: true, p: 601 })} onClick={() => setIsOpenAP(false)}>
                Book High School Senior Portrait Appointment
              </Link>
            </li>
            <li>
              <Link to={routes.scheduleAppointment({ senior: false })} onClick={() => setIsOpenAP(false)}>
                Book Elementary School Appointment
              </Link>
            </li>
            
          </ul>
            
          </li>
        <li>
          <Link to={routes.downloadImageForm()}>
            Download Digital Files
          </Link>
        </li>
        <li>
          <a href="/yearbooks">Yearbooks</a>
        </li>
        <li>
          <a href={getCurrentDomain() === 'https://www.shoob.cloud' ? 'https://www.shoobphotosouth.com/contact1' : '/contacts/new'}>
            Contact Us
          </a>
        </li>
        <li>
          <a href="/school_resources">
            Resources for Schools
          </a>
        </li>
        <li>
          <Link to={routes.registration()}>
            Register
          </Link>
        </li>
        <li>
            <a href='/privacy-policy'>
              Privacy &amp; Data Policy
            </a>
          </li>
      </ul>
      <Link className={styles.cartLink} to={routes.cart()} style={{ paddingRight: '1em' }}>
        <div style={{ position: 'relative' }}>
          <Image src={cart} />
          {data && <span style={{ textAlign: 'center', position: 'absolute', bottom: '-6px', background: '#fff', width: '20px', height: '20px', borderRadius: '50%', right: '-14px', padding: '.1rem' }}>{data}</span>}
        </div>
      </Link>
    </nav>
  );
}
